import { Suspense, useEffect, useMemo, useState } from "react";

import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import Tabla from '../../../../components/ui/materialui/tabla';
import { useColumnsResumenTotales } from "../utils/columnsResumenTotales";
import { useValidadorAsientosContablesContext } from "../../../../context/validadorAsientosContablesContext";
import { DatosTotalesDto } from "../models/resumenesTotales";
import { numericFormatter } from "react-number-format";

const formatearNumero = (numero: number): string => numericFormatter((numero ?? 0).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": " $" });

function ResumenTotalesComponent() {

    const { totalesMovimientosContables } = useValidadorAsientosContablesContext();
    const { COLUMNS } = useColumnsResumenTotales();
    const columns = useMemo(() => COLUMNS, []);

    const [ totales, setTotales ] = useState<DatosTotalesDto[]>([]);

    useEffect(() => {
        const total: DatosTotalesDto = { key: 'Totales', debito: formatearNumero(totalesMovimientosContables?.totalDebitos || 0), credito: formatearNumero(totalesMovimientosContables?.totalCreditos || 0) };
        const descuadrados: DatosTotalesDto = { key: 'Descuadrados', debito: formatearNumero(totalesMovimientosContables?.descuadreDebitos || 0), credito: formatearNumero(totalesMovimientosContables?.descuadreCreditos || 0) };
        const pendientes: DatosTotalesDto = { key: 'Pendientes VºBº', debito: formatearNumero(totalesMovimientosContables?.pendienteDebitos || 0), credito: formatearNumero(totalesMovimientosContables?.pendienteCreditos || 0) };
        const vistoBueno: DatosTotalesDto = { key: 'Visados', debito: formatearNumero(totalesMovimientosContables?.visadoDebitos || 0), credito: formatearNumero(totalesMovimientosContables?.visadoCreditos || 0) };
        const enviados: DatosTotalesDto = { key: 'Enviados', debito: formatearNumero(totalesMovimientosContables?.enviadoDebitos || 0), credito: formatearNumero(totalesMovimientosContables?.enviadoCreditos || 0) };
        setTotales([total, descuadrados, pendientes, vistoBueno, enviados]);
    }, [totalesMovimientosContables]);


    return (
        <CustomAccordion title={'Resumen totales'} expandedDefault>
            <Suspense>
                <Tabla
                    columns={columns}
                    data={totales}
                    showFooter={false}
                />
            </Suspense>
        </CustomAccordion>
    )
}

export default ResumenTotalesComponent;